<template>
  <div class='mainContainer' v-loading='importLoading'>
    <div class='nav'>
      <div class='navContainer' style='width: 230px'>
        <p>委托商：</p>
        <el-input v-model='entrustIpt' size='mini' style='width:150px' placeholder='请输入委托商'/>
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>批次号：</p>
        <el-input v-model='batchIpt' size='mini' style='width:150px' placeholder='请输入批次号'/>
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>运单编号：</p>
        <el-input v-model='waybillIpt' size='mini' style='width:150px'
                  placeholder='请输入运单编号'/>
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>品牌：</p>
        <el-input v-model='brandIpt' size='mini' style='width:150px' placeholder='请输入品牌'/>
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>台账月：</p>
        <el-input v-model='monthIpt' size='mini' style='width:150px' placeholder='请输入台账月'/>
      </div>
      <div class='navContainer' style='width: 300px'>
        <p style="width: 130px">原结算对账编号：</p>
        <el-input v-model='actNoSub' size='mini' style='width:170px' placeholder='请输入原结算对账编号'/>
      </div>
      <div class='navContainer' style='width: 300px'>
        <p style="width: 130px">原结算对账标题：</p>
        <el-input v-model='titleSub' size='mini' style='width:170px' placeholder='请输入原结算对账标题'/>
      </div>
      <div class='navContainer' style='width: 400px'>
        <p>计划日期：</p>
        <el-date-picker
          v-model="timeIpt"
          type="daterange"
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini">
        </el-date-picker>
        <el-date-picker v-if="false" v-model='timeIpt[0]' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        @change='dateChange1' type='date' placeholder='开始日期'/>
        <span v-if="false" style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
        <el-date-picker v-if="false" v-model='timeIpt[1]' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        @change='dateChange1' type='date' placeholder='结束日期'/>
      </div>
      <div class='navContainer' style='width: 400px'>
        <p>交车日期：</p>
        <el-date-picker
          v-model="dealersIpt"
          type="daterange"
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="mini">
        </el-date-picker>
        <el-date-picker v-if="false" v-model='dealersIpt[0]' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        @change='dateChange2' type='date' placeholder='开始日期'/>
        <span v-if="false" style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
        <el-date-picker v-if="false" v-model='dealersIpt[1]' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        @change='dateChange2' type='date' placeholder='结束日期'/>
      </div>
      <div class='navContainer' style='width: 270px'>
        <p style='width:120px !important'>是否生成对账单：</p>
        <el-select v-model='stateIpt' filterable size='mini' style='width:150px'
                   placeholder='请选择'>
          <el-option v-for='item in stateOption' :key='item.label' :label='item.label'
                     :value='item.value'/>
        </el-select>
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <el-button size='small' type='primary' @click='addBtn'>生成对账单</el-button>
        <el-button size='small' type='primary' @click='refreshBtn'>刷新补结算</el-button>
        <!--        <el-button size='small' type='primary' @click='ledgerRevise'>修改台账月</el-button>-->
      </div>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='download' class='pointer'>模板下载</span>
        <span style='cursor: pointer;display: inline-block;'>
          <import-statement @getList='searchBtn' @changeImportLoading='changeImportLoading'
                            :type='22'/>
        </span>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer' >
        <el-table v-loading='tableLoading' :data='dataOne' style='width: 100%' border stripe
                  ref='multipleTable'
                  @select='handleCurrentChange' @select-all='handleCurrentChange'
                  :reserve-selection='true'
                  :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', 'height': '48px', background: '#E8E8E8' }"
                  :cell-style="{ 'color': '#3b3b3b', 'font-size': '13px', 'height': '35px', }"
                  :row-key='(row) => { return row.id }' :row-style="rowStyle">
          <el-table-column type='selection' align='center' width='50px'
                           :selectable='(row) => { return row.isReconciliation !== 1 }'/>
          <el-table-column prop='consignorName' label='委托商' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='batchNumber' label='批次号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='waybillNo' label='运单编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='frameNumber' label='车架号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='startPortName' label='起始港' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='deliveryPortName' label='目的港' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='standingBookMonth' label='台账月' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='brandName' label='品牌' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='modelName' label='型号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='plannedDate' label='计划日期' width='160px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.plannedDate | tableValueFormat('plannedDate') }}
            </template>
          </el-table-column>
          <el-table-column prop='deliveryDate' label='交车日期' width='160px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.deliveryDate | tableValueFormat('deliveryDate') }}
            </template>
          </el-table-column>
          <el-table-column prop='taxRate' label='税率(%)' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column label='单价' width='160px' align='center' :formatter='priceFormat'
                           show-overflow-tooltip/>
          <el-table-column prop='taxContractPrice' label='含税合同价' width='160px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.taxContractPrice ? scope.row.taxContractPrice : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop='taxPreparePrice' label='含税预结算价' width='160px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.taxPreparePrice ? scope.row.taxPreparePrice : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop='difPrice' label='差价' width='160px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.difPrice ? scope.row.difPrice : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop='isReconciliation' label='生成对账单' width='160px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.isReconciliation | tableValueFormat('isReconciliation') }}
            </template>
          </el-table-column>
          <el-table-column prop='actNo' label='对账单编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='title' label='对账单标题' width='180px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.title ? scope.row.title : '--' }}
            </template>
          </el-table-column>
          <el-table-column prop='actNoSub' label='原结算对账编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='titleSub' label='原结算对账标题' width='160px' align='center'
                           show-overflow-tooltip/>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes='[50, 100, 500, 1000,2000]'
                       layout='sizes,prev, pager, next,jumper' :total='total'
                       @size-change='contractSizeChange' @current-change='contractCurrentChange'
                       @prev-click='contractCurrentChange'
                       @next-click='contractCurrentChange'/>
      </div>
    </div>
    <!-- 对账单 -->
    <el-dialog :title="importShow ? '导入生成对账单' : '生成对账单'" :visible.sync='dialogVisible'
               :width='dialogWith' center
               @close='dialogClose'>
      <!--  check-table-data 传入需要展示的数据     -->
      <!--  importShow  判断是否是导入生成对账单or 生成对账单   -->
      <!--  selectionTable 运单费用操作删除触发  传出删除后数据据 多选表格联动 重新勾选   -->
      <consignor-resources-car-add-account  @closeDialogAndSearch='closeDialogAndSearch'
                                       :importShow='importShow'
                                       :settlement='settlement' ref='accountState'>
        <template slot='label'>基础信息</template>
        <template slot='label2'>运单费用</template>
      </consignor-resources-car-add-account>
    </el-dialog>
  </div>
</template>

<script>
import checkTable from '@/components/checkTable.vue';
import consignorResourcesCarAddAccount
  from '@/views/settle/entrust/components/consignorResourcesCarAddAccount';
import {
  addSettlementFreightResources,
  consignmentPage
} from '@/service/basicfile';
import {formatDateTime, getSessionStore} from '@/config/mUtils';
import {baseUrl} from '@/config/env';
import ImportStatement from '@/views/settle/entrust/components/import-statement';

export default {
  components: {
    checkTable,
    consignorResourcesCarAddAccount,
    ImportStatement,
  },
  data() {
    return {
      activeName: 'first', // 生成对账单弹窗默认显示
      batchIpt: '', // 批次号
      waybillIpt: '', // 运单编号
      chassisIpt: '', // 底盘号
      entrustIpt: '', // 委托商
      brandIpt: '', // 品牌名称
      monthIpt: '', // 台账月
      actNoSub: '', // 原结算对账编号
      titleSub: '', //原结算对账标题
      dealersIpt: ['', ''], // 交车日期
      timeIpt: ['', ''], // 计划日期
      stateIpt: '', // 是否生成对账单
      termsIpt: '', // 运输方式
      // 是否生成对账单下拉数据
      stateOption: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 0,
          label: '否',
        },
        {
          value: 1,
          label: '是',
        },
        {
          value: 2,
          label: '部分生成',
        },
      ],
      // 运输方式
      termsOption: [
        {
          value: '',
          label: '全部',
        },
        {
          value: 1,
          label: '公路',
        },
        {
          value: 2,
          label: '水路',
        },
        {
          value: 3,
          label: '水陆联运',
        },
      ],
      page: 1,
      size: 10,
      total: 0,
      dialogVisible: false, // 生成对账单弹窗是否显示
      dialogWith: '950px', // 生成对账单弹窗宽度
      importShow: true, // 判断是否是导入生成对账单（ture） or生成对账单
      // 生成对账单弹窗提示信息
      rules: {
        type: [
          {
            required: true,
            message: '请选择地址类型',
            trigger: 'change',
          },
        ],
        name: [
          {
            required: true,
            message: '请输入地址名称',
            trigger: 'blur',
          },
        ],
        address: [
          {
            required: true,
            message: '请输入详细地址',
            trigger: 'blur',
          },
        ],
        area: [
          {
            required: true,
            message: '请现在所在区域',
            trigger: 'change',
          },
        ],
      },
      oldList: {},
      expands: [],
      minTable: [], // 二级表格选中数据
      // table的各种数据
      // 一级表头
      columnOne: [
        {
          id: 'th20',
          width: '150',
          title: '委托商',
          name: 'consignorName',
        },
        {
          id: 'th1',
          width: '150',
          title: '批次号',
          name: 'batchNumber',
        },
        {
          id: 'th2',
          width: '150',
          title: '运单编号',
          name: 'waybillNo',
        },
        {
          id: 'th3',
          width: '160',
          title: '车架号',
          name: 'frameNumber',
        },
        {
          id: 'th4',
          width: '100',
          title: '品牌',
          name: 'brandName',
        },
        {
          id: 'th5',
          width: '100',
          title: '型号',
          name: 'modelName',
        },
        {
          id: 'th6',
          width: '150',
          title: '起始地',
          name: 'departurePlace',
        },
        {
          id: 'th7',
          width: '150',
          title: '交车地',
          name: 'arrivePlace',
        },
        {
          id: 'th19',
          width: '120',
          title: '台账月',
          name: 'standingBookMonth',
        },
        {
          id: 'th8',
          width: '110',
          title: '计划日期',
          name: 'plannedDate',
        },
        // {id:'th9',width:'110', title:'发运日期', name: 'dispatchDate'},
        {
          id: 'th10',
          width: '110',
          title: '交车日期',
          name: 'deliveryDate',
        },
        {
          id: 'th11',
          width: '70',
          title: '运输方式',
          name: 'transportationTerms',
        },
        {
          id: 'th12',
          width: '60',
          title: '税率(%)',
          name: 'taxRate',
        },
        {
          id: 'th13',
          width: '80',
          title: '含税合同价',
          name: 'taxContractPrice',
        },
        {
          id: 'th14',
          width: '90',
          title: '不含税合同价',
          name: 'contractPrice',
        },
        // {id:'th15',width:'90', title:'预结算方式', name: 'prepareType'},
        {
          id: 'th15',
          width: '100',
          title: '含税预结算价',
          name: 'taxPreparePrice',
        },
        {
          id: 'th16',
          width: '110',
          title: '不含税预结算价',
          name: 'preparePrice',
        },
        {
          id: 'th17',
          width: '80',
          title: '油价联动金额',
          name: 'oilPrice',
        },
        {
          id: 'th18',
          width: '80',
          title: '生成对账单',
          name: 'isReconciliation',
        },
        {
          id: 'th18',
          width: '120',
          title: '对账单编号',
          name: 'title',
        },
      ],
      // 列表数据
      dataOne: [],
      // 二级表头
      columnTwo: [
        // {id:'td-th1', width:'120', title:'运单编号', name: 'waybillNo'},
        {
          id: 'td-th1',
          width: '150',
          title: '运输方式',
          name: 'transportationTerms',
        },
        {
          id: 'td-th2',
          width: '150',
          title: '起始地',
          name: 'departurePlace',
        },
        {
          id: 'td-th3',
          width: '150',
          title: '交车地',
          name: 'arrivePlace',
        },
        {
          id: 'td-th4',
          width: '150',
          title: '台账月',
          name: 'standingBookMonth',
        },
        {
          id: 'td-th5',
          width: '150',
          title: '含税合同价',
          name: 'taxContractPrice',
        },
        {
          id: 'td-th6',
          width: '150',
          title: '不含税合同价',
          name: 'contractPrice',
        },
        // {id:'td-th5', width:'120', title:'预结算方式', name: 'prepareType'},
        {
          id: 'td-th7',
          width: '150',
          title: '含税预结算价',
          name: 'taxPreparePrice',
        },
        {
          id: 'td-th8',
          width: '150',
          title: '不含税预结算价',
          name: 'preparePrice',
        },
        {
          id: 'td-th9',
          width: '80',
          title: '油价联动金额',
          name: 'oilPrice',
        },
        {
          id: 'th18',
          width: '120',
          title: '对账单编号',
          name: 'title',
        },
        // {
        //   id: 'td-th10',
        //   width: '150',
        //   title: '生成对账单',
        //   name: 'isReconciliation',
        // },
      ],
      childName: 'childs', // 子表格数组名
      // 其他字段
      tableField: {
        terms1: 'transportationTerms', // 一级菜单的运输方式字段
        terms2: 'transportationTerms', // 二级菜单的运输方式字段
        termsChick: true, // 运输方式全选框是否显示
        importExport: true, // 导入导出是否显示
        select: true, // 是否显示复选框
      },
      checkData: [], // 选中数据
      settlement: '', // 生成对账单时的结算方式
      // 修改台账月
      ledgerVisible: false,
      ledgerLoad: false,
      ledger: '',
      ledgerData: [],
      importLoading: false,
      tableData: [],
      tableLoading: false,
    };
  },
  filters: {
    tableValueFormat(val, rowName) {
      if (rowName === 'isReconciliation') {
        switch (parseInt(val)) {
          case 0:
            return '否';
          case 1:
            return '是';
          case 2:
            return '部分生成';
        }
      } else if (rowName === 'plannedDate') {
        return val ? formatDateTime(val, 'yyyy-mm-dd') : '';
      } else if (rowName === 'dispatchDate') {
        return val ? formatDateTime(val, 'yyyy-mm-dd') : '';
      } else {
        return val;
      }
    },
  },
  computed: {
    // 运输方式下拉框数据
    getTerms() {
      // console.log('getTerms');
      return function (terms) {
        switch (terms) {
          case 1:
            return '公路';
          case 2:
            return '水路';
          case 3:
            return '水陆联运';
        }
      };
    },
    // 是否生成对账单下拉框数据
    getState() {
      // console.log('getState');
      return function (state) {
        switch (state) {
          case 0:
            return '否';
          case 1:
            return '是';
        }
      };
    },
  },
  watch: {},
  mounted() {
    // this.allTrSelect(this.dataOne);
    // this.searchBtn();
  },
  methods: {
    priceFormat(row) {
      if (row.taxContractPrice && row.carNumber) return row.taxContractPrice / row.carNumber;
      return '--';
    },
    // 重置方法
    resetBtn() {
      this.stateIpt = '';
      this.batchIpt = '';
      this.waybillIpt = '';
      this.chassisIpt = '';
      this.brandIpt = '';
      this.monthIpt = '';
      this.entrustIpt = '';
      this.dealersIpt = ['', ''];
      this.timeIpt = ['', ''];
      this.termsIpt = '';
    },
    // 页面查询调用方法
    searchBtn() {
      this.page = 1;
      this._shippingFeeSettlement();
    },
    //刷新补结算
    async refreshBtn() {
      const data = {
        consignorName: this.entrustIpt, // 委托商
        batchNumber: this.batchIpt, // 批次号
        waybillNo: this.waybillIpt, // 运单编号
        frameNumber: this.chassisIpt, // 车架号
        brandName: this.brandIpt, // 品牌名称
        standingBookMonth: this.monthIpt, // 台账月
        transportationTerms: this.termsIpt, // 运输方式
        titleSub: this.titleSub,
        planStartDate: this.timeIpt[0] === undefined ? '' : this.timeIpt[0], // 计划日期
        planEndDate: this.timeIpt[1] === undefined ? '' : this.timeIpt[1], // 计划日期后
        deliveryStartDate: this.dealersIpt[0] === undefined ? '' : this.dealersIpt[0], // 交车日期
        deliveryEndDate: this.dealersIpt[1] === undefined ? '' : this.dealersIpt[1], // 交车日期后
        isReconciliation: '', // 是否生成对账单
        actNoSub: this.actNoSub, //原结算对账编号
      };
      this.tableLoading = true
      const res = await addSettlementFreightResources(data)
      this.tableLoading = false
      if (res.status !== 0) return this.$message.warning(res.message);
      this._shippingFeeSettlement()

    },
    compareDate(d1, d2) {
      return new Date(d1.replace(/-/g, '\/')) > new Date(d2.replace(/-/g, '\/'));
    },
    dateChange1(val) {
      if (this.timeIpt[1] && this.timeIpt[0] && this.compareDate(this.timeIpt[0], this.timeIpt[1])) {
        if (val == this.timeIpt[1]) this.timeIpt[1] = '';
        if (val == this.timeIpt[0]) this.timeIpt[0] = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    dateChange2(val) {
      if (this.dealersIpt[1] && this.dealersIpt[0] && this.compareDate(this.dealersIpt[0], this.dealersIpt[1])) {
        if (val == this.dealersIpt[1]) this.dealersIpt[1] = '';
        if (val == this.dealersIpt[0]) this.dealersIpt[0] = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    // 生成对账单按钮 —— 提示
    addBtn() {
      if (this.checkData.length <= 0) {
        return this.$message.warning('请至少选择一条结算数据！');
      }
      let consignorFlag = false; // 委托商
      let taxFlag = false; // 税率
      let reconciliationFlag = false; // 是否生成对账单
      if (this.checkData.length > 0) {
        const {
          consignorId,
          taxRate,
        } = this.checkData[0];
        this.checkData.forEach((item) => {
          if (item.consignorId !== consignorId) {
            consignorFlag = true;
          }
          if (item.taxRate !== taxRate) {
            taxFlag = true;
          }
          if (item.isReconciliation) {
            reconciliationFlag = true;
          }
        });
      }
      if (consignorFlag) return this.$message.warning('只能选择同一家委托商数据！');
      if (reconciliationFlag) return this.$message.warning('部分数据已生成对账单！');
          let type = false;
          this.checkData.forEach((item) => {
            if (!item.taxContractPrice || item.taxContractPrice == '' || !item.contractPrice || item.contractPrice == '') {
              type = true;
            }
          });
          // 生成对账单弹窗显示
          this.dialogVisible = true;
          this.$nextTick(() => {
            // 传入表格数据
            this.$refs.accountState.init(this.checkData);
             this.$refs.accountState.type = 10
          });
          // 判断是否是导入生成对账单
          this.importShow = false;
    },
    // 关闭弹窗并刷新页面
    closeDialogAndSearch() {
      this.dialogClose();
      this.searchBtn();
    },
    // 每页显示行数切换
    contractSizeChange(sizes) {
      this.size = sizes;
      this._shippingFeeSettlement();
    },

    // 跳转到某一页/切换页码
    contractCurrentChange(page) {
      this.page = page;
      this._shippingFeeSettlement();
    },
    // 保存生成对账单数据
    saveClick() {
      // console.log('saveClick');
    },
    // 关闭生成对账单弹窗
    dialogClose() {
      this.dialogVisible = false;
      this.$refs.accountState.activeName = 'information';
    },
    // 不知道没有调用
    addClick() {
      // console.log('addClick');
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.basicInfoData = {};
          this.dialogVisible = false;
        } else {
          return false;
        }
      });
    },

    // 运单费用中删除某一行数据
    deleteClick() {
      // console.log('deleteClick');
    },


    // 选中数组改变
    checkChang(data) {
      this.checkData = data;
    },
    // 弹窗中删除指定下标数据
    delCheck(index) {
      this.$refs.del.cancelCheck(index);
    },
    // 导入生成对账单
    importStatement() {
      // 生成对账单弹窗显示
      this.dialogVisible = true;
      //  判断是否是导入生成对账单
      this.importShow = true;
    },
    // 导出数据
    exportData() {
      let token = getSessionStore('token');
      let url = baseUrl + '/platform/settlement/consignorLine/add/exportResourcesCarXls?access_token='+token
      const exportParams = {
        consignorName: this.entrustIpt,
        batchNumber: this.batchIpt,
        waybillNo: this.waybillIpt,
        frameNumber: this.chassisIpt,
        brandName: this.brandIpt,
        standingBookMonth: this.monthIpt,
        transportationTerms: this.termsIpt,
        planStartDate: this.timeIpt[0] || '',
        planEndDate: this.timeIpt[1] || '',
        deliveryStartDate: this.dealersIpt[0] || '',
        deliveryEndDate: this.dealersIpt[1] || '',
        isReconciliation: this.stateIpt,
      }
      window.exportExcel(url, exportParams, '委托商资源车托运费用补结算');
    },
    // 分页查询 -- 查询条件
    _shippingFeeSettlement() {
      const data = {
        consignorName: this.entrustIpt, // 委托商
        batchNumber: this.batchIpt, // 批次号
        waybillNo: this.waybillIpt, // 运单编号
        frameNumber: this.chassisIpt, // 车架号
        brandName: this.brandIpt, // 品牌名称
        standingBookMonth: this.monthIpt, // 台账月
        transportationTerms: this.termsIpt, // 运输方式
        planStartDate: this.timeIpt[0] === undefined ? '' : this.timeIpt[0], // 计划日期
        planEndDate: this.timeIpt[1] === undefined ? '' : this.timeIpt[1], // 计划日期后
        deliveryStartDate: this.dealersIpt[0] === undefined ? '' : this.dealersIpt[0], // 交车日期
        deliveryEndDate: this.dealersIpt[1] === undefined ? '' : this.dealersIpt[1], // 交车日期后
        isReconciliation: this.stateIpt, // 是否生成对账书
        actNoSub: this.actNoSub, //原结算对账单编号
        titleSub: this.titleSub,
        page: this.page,
        rows: this.size,
      };
      this.consignmentPage(data)
    },
    // 资源车
    async consignmentPage(params) {
      this.dataOne = [];
      this.importLoading = true
      const data = await consignmentPage(params);
      this.importLoading = false
      if (data.status !== 0) return this.$message.warning(data.message);
      this.dataOne = data.data.records;
      this.total = data.data.total;
    },
    rowStyle({ row }) {
      return this.checkData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    // 多选事件触发
    handleCurrentChange(val) {
      this.checkData = val;

      let Waybill = '';
      const array = val.filter((item, index) => {
        if (index === 0) Waybill = item.consignorName;
        return Waybill !== item.consignorName;
      });
      // 筛选  供应商相同数据
      this.checkData = val.filter(item => Waybill === item.consignorName);
      let tipOne = true;
      array.forEach((value) => {
        // 只有使用表格原数据，才会生效   从表格原数据中赛选
        if (tipOne) {
          this.$message.warning('只能选择相同的供应商');
          tipOne = false;
        }
        this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => value.id === item.id), false);
      });

      // this.$refs.accountState.calculation()
    },
    searchCopyFormat(value, flag) {
      let splitArr = value.clipboardData.getData('Text')
        .replace(/\s/g, ',')
        .split(',');
      splitArr = splitArr.filter(item => item);
      splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
      switch (flag) {
        case 'chassisIpt':
          this.chassisIpt = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
          break;
      }
    },

    download() {
      window.location.href = '/file/委托商托运费导入模板（资源车）.xlsx';
    },
    changeImportLoading(flag) {
      this.importLoading = flag;
    },
  },
};
</script>

<style lang='scss' scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;
  margin-top: 30px;

  .tabs {
    float: left;
    margin-left: 20px;
    margin-top: 2px;
    display: flex;
    justify-content: space-between;
    width: 339px;
    margin-bottom: 20px;

    div {
      //background: #ccc;
      width: 120px;
      height: 30px;
      line-height: 30px;
      color: #48599E;
      text-align: center;
      font-size: 13px;
      cursor: pointer;
      border: 1px solid #48599E;
      font-weight: 700;
      transition: all .3s;
    }

    .left {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    .right {
      /*width: 160px;*/
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .active {
      background: #48599E;
      color: #fff;
    }
  }

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .navContainer p {
      display: inline-block;
      width: 80px;
      text-align: right;
    }

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 15px;

    &Nav {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      &Left {
        ::v-deep {
          .el-checkbox__label {
            color: #727070;
            font-size: 12px;
          }
        }
      }

      &Right {
        span {
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          text-decoration: underline;
          margin-right: 10px;

          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    .tableContainer {
      margin-top: 10px;
      margin-bottom: 25px;
      width: 100%;

      ::v-deep {
        .el-table__expand-icon:after {
          content: '';
        }

        .el-table__expand-icon > i {
          display: none;
        }

        .el-table__expand-column {
          border-right: none;
        }

        body .el-table th.gutter {
          display: table-cell !important;
        }

        .el-checkbox {
          margin-left: 16px;
        }

        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0;
        }

        .el-table td {
          padding: 0;
        }

        .el-table th > .cell {
          font-weight: 700 !important;
        }

        .el-table__header .el-table-column--selection .cell .el-checkbox:after {
          color: rgb(127, 127, 127);
          content: "全选";
          font-size: 12px;
          font-weight: 700;
          //margin-left: 2px;
        }

        .el-table__header .el-table-column--selection .cell .el-checkbox {
          margin-left: 8px;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  .depart {
    width: 100%;
    padding: 20px;

    &Basic {
      display: flex;
      flex-direction: column;

      &Title {
        display: flex;
        align-items: flex-end;

        p {
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
    }

    ::v-deep.feight {
      .el-table__expanded-cell {
        padding: 0;
        text-align: end;

        .el-table {
          left: 10%;
        }
      }

      .el-table__expand-icon > i {
        display: none;
      }

      .el-table .cell {
        padding: 0;
      }

      .el-table th {
        padding: 0;
      }

      .el-table td {
        padding: 0;
      }

      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }

    ::v-deep {
      .el-tabs__active-bar {
        height: 4px;
      }

      .el-tabs__nav-wrap::after {
        height: 4px;
      }

      .el-form-item__label {
        font-weight: 700;
      }

      .el-form-item {
        margin-bottom: 13px;
      }

      .el-form-item__label {
        padding: 0;
      }

      .el-form-item__content {
        position: relative;
      }
    }
  }

  .permissions {
    width: 100%;
    padding: 20px 10px 20px 50px;

    .name {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        color: #2F1010;
      }
    }

    .content1 {
      p {
        color: #2F1010;
      }
    }

    .tree {
      border: 1px solid #D2D2D2;
      width: 400px;
      height: 280px;
      margin-left: 60px;
      border-radius: 5px;
      padding: 5px;
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px 0 10px 0;

      button {
        margin: 0 15px;
      }
    }
  }

  .ledger {
    padding: 20px;
    max-height: calc(70vh - 60px);
    overflow-y: auto;

    .leader-input {
      display: inline-block;
      width: 100%;
      margin-bottom: 15px;

      span {
        display: inline-block;
        width: 100px;
      }

      ::v-deep {
        .el-input.el-input--small {
          display: inline-block;
          width: 200px;
        }
      }
    }

    span.dialog-footer {
      display: inline-block;
      width: 100%;
      padding: 20px 0 10px;
      text-align: center;
    }

    ::v-deep {
      .el-table td {
        padding: 5px;
      }

      .el-table td,
      .el-table th {
        font-size: 13px;
        padding: 5px;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }
}

::v-deep {
  .consignorAccount {
    max-height: 500px;
    overflow: auto;
  }
}

.exportButton {
  span {
    color: rgba(51, 136, 255, 1);
    margin-right: 10px;
    font-size: 14px;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
